/** Versioned, frozen Trainnova 20 m schedule. External table validation pending. */
const DISTANCE_PER_SHUTTLE = 20; // metres (one 20 m length)
const LEVEL_TARGET_SECONDS = 60; // each level ≈ 1 minute

export function buildLegerLevels(startSpeed = 8.5, increment = 0.5, numLevels = 21) {
  const levels = [];
  for (let i = 0; i < numLevels; i++) {
    const level = i + 1;
    const speed = +(startSpeed + i * increment).toFixed(2);
    const shuttleDuration = DISTANCE_PER_SHUTTLE / (speed / 3.6); // seconds, precise
    const shuttles = Math.max(1, Math.round(LEVEL_TARGET_SECONDS / shuttleDuration));
    levels.push({
      level,
      speed,
      shuttles,
      shuttleDuration,
      recoveryDuration: 0, // beep test has no recovery between shuttles
    });
  }
  return levels;
}

export const beepTestProtocol = {
  testId: 'beep_test',
  variantId: 'beep_20m_leger_8_5_default',
  name: 'Beep test',
  displayName: '20 m Multistage Fitness Test',
  shortLabel: 'Beep test 20 m Léger 8.5',
  spokenName: 'Twenty meter shuttle test',
  distancePerShuttle: DISTANCE_PER_SHUTTLE,
  outAndBack: false, // single 20 m length, continuous (one line beep per shuttle, no recovery)
  hasRecovery: false,
  startSpeed: 8.5, // km/h, level 1 (Léger default — NOT 8.0)
  speedIncrement: 0.5, // km/h per level
  scoring: 'Senast fullbordade 20 m-shuttle (nivå.shuttle).',
  verified: false,
  variant: 'leger_8.5',
  source:
    'Léger & Lambert (1982); Léger et al. (1988). 20 m Multistage Fitness Test, 1-minute stages, start 8.5 km/h, +0.5 km/h/nivå.',
  notes: 'Fast Trainnova-tabell: 238 sträckor, 4760 m. Extern protokollverifiering återstår. Tidigare resultat omräknas inte.',
  // Frozen existing Trainnova table. Not certified as an external reference recording.
  protocolVersion: 'trainnova-beep20-238-v2',
  levels: [7,8,8,8,9,9,10,10,10,11,11,12,12,13,13,13,14,14,15,15,16].map((shuttles, i) => ({
    level: i + 1, speed: 8.5 + i * 0.5, shuttles,
    shuttleDuration: 72 / (8.5 + i * 0.5), recoveryDuration: 0,
  })),
};

export default beepTestProtocol;
